module.exports = __webpack_public_path__ + "static/media/queen.8f7842c9.svg";